import { FfsPart } from 'features/indicationTriage/cards/ffsCalc/ffsResultPublish/ffsTypes'
import { FfsPartStep } from 'features/libra/stepComponents/ffs/FfsPartStep'
import { LibraWorflowStepComponentProps } from 'features/libra/workflow/workflowStepsApi'
import { FC } from 'react'

/**
 * FFS Part 4 (general metal loss) workflow step. Thin wrapper binding the
 * shared `FfsPartStep` core to `FfsPart.PART_4`.
 *
 * TODO(ffs-preplanning): API 579 Part 4 is conceptually a GENERAL /
 * COMPONENT-level metal-loss assessment, but this runs it PER-LTA — the calc
 * crops the thickness CDF to each LTA's `selection` and uses that box as the
 * Part 4 averaging window (see `part4/FfsDataValuesSection.tsx`). That scale was
 * inherited from the indication-scoped stack (`useIndicationData`,
 * `FfsSharedValues`, `ffs-lta-report` tagged by `indication`), not chosen from
 * the engineering. Revisit making Part 4 component/region-level (one assessment
 * per component/region, full-CDF CTPs, report tagged by `component`, single-panel
 * step like `FfsMinimumThicknessStep`) when building the FFS pre-planning step —
 * that is where the Part 4 (component) vs Part 5 (per-LTA) scale rule belongs.
 */
export const Component: FC<
  LibraWorflowStepComponentProps<Record<string, never>>
> = ({ readonly = false }) => (
  <FfsPartStep ffsPart={FfsPart.PART_4} readonly={readonly} />
)
